import { SaveReportRequestParams, useFiltersStore } from '@/hooks'
import { useAnalyticsFiltersStore } from '../stores/useAnalyticsFiltersStore/useAnalyticsFiltersStore'
import { mapAnalyticsFiltersSaveParams } from '../stores/useAnalyticsStore/mapAnalyticsFiltersSaveParams'

export const useAnalyticsFiltersSaveParams = () => {
    const activeAnalyticsFilters = useAnalyticsFiltersStore(
        (state) => state.activeFilters
    )

    const rootNode = useFiltersStore((state) => state.rootNode)

    const params = mapAnalyticsFiltersSaveParams(activeAnalyticsFilters)
    const analyticsFiltersParams: SaveReportRequestParams = {
        ...params,
        unitOfMeasureId: Array.isArray(params.unitOfMeasureId)
            ? undefined
            : params.unitOfMeasureId,
    }

    if (!analyticsFiltersParams.nodeIds.length && rootNode && rootNode.nodeId) {
        analyticsFiltersParams.nodeIds = [rootNode.nodeId]
    }

    return analyticsFiltersParams
}
